var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout sample-profile type-report"},[_c('sample-navbar'),_c('div',{staticClass:"wrapper report",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('app-side-bar',{attrs:{"mini":false,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: 'about-data',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Summary Scores',
            icon: 'star_half',
            path: 'summary-score',
          }}}),(!this.report.spif)?_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'industry-summary' }),expression:"{ name: 'industry-summary' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Industry Summary',
              icon: 'chat_bubble',
              path: 'industry-summary',
            }}})],1):_vm._e(),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'balance-sheet' }),expression:"{ name: 'balance-sheet' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Financials',
              icon: 'trending_up',
              path: 'profit-loss',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Ratios',
            icon: 'scatter_plot',
            path: 'financial-ratios',
          }}}),(this.report.spif)?[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Cash flow-Solvency',
              icon: 'money',
              path: 'cash-ratios-variance',
            }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Profitability',
              icon: 'payments',
              path:
                'profitability-ratios-variance',
            }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Efficiency',
              icon: 'pie_chart',
              path: 'efficiency-ratios-variance',
            }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Debt-Risk',
              icon: 'report',
              path: 'debt-risky-ratios-variance',
            }}})]:_vm._e(),(this.report.spif)?_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cash Tables',
            icon: 'collections_bookmark',
            path: 'cash-tables',
          }}}):_vm._e(),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Valuation Multiple',
              icon: 'addchart',
              path: 'valuation-multiples',
            }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Customize Report',
            icon: 'tune',
            path: 'customize-report',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Manage Inputs',
            icon: 'settings',
            path: 'manage-inputs',
          }}})],2)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }